export function validateEmailInput(value): boolean {
  const re =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const isValid = re.test(value);
  return isValid;
}

export function validatePasswordValue(value): boolean {
  const re = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
  const isValid = re.test(value);
  return isValid;
}

export function validDomainValue(value): boolean {
  const re = /^[^0-9][^A-Z][a-z\-0-9]{0,20}$/;
  const isValid = re.test(value);
  return isValid;
}
